import { ApiProperty } from '@nestjs/swagger';
import { DeviceInterface } from '../interfaces/device.interface';
import { CommonEntityDto } from '../../common/dto/common-entity.dto';
import { DeviceType } from '../enums/device-type.enum';
import { IsEnum, IsString, IsUUID } from 'class-validator';
import { Exclude, Expose } from 'class-transformer';

@Exclude()
export class DeviceDto extends CommonEntityDto implements DeviceInterface {
  /**
   * Device Type
   */
  @ApiProperty({
    title: 'Device Type',
    description: 'The device operating system type.',
    enum: DeviceType,
  })
  @Expose()
  @IsEnum(DeviceType)
  deviceType!: DeviceType;

  /**
   * Device Token
   */
  @ApiProperty({
    title: 'Device Token',
    description: 'The device token string.',
  })
  @Expose()
  @IsString()
  deviceToken!: string;

  /**
   * FCM Token
   */
  @ApiProperty({
    title: 'Firebase Push Token',
    description: 'The firebase push token for this device.',
  })
  @Expose()
  @IsString()
  fcmToken!: string;

  /**
   * User ID
   */
  @ApiProperty({
    type: 'string',
    format: 'uuid',
    title: 'User Id',
    description: 'The id of the User associated with this resource.',
  })
  @Expose()
  @IsUUID()
  userId!: string;
}
